export const initModal = (input) => ({
  type: "INIT_MODAL",
  input,
});

export const toggleModal = () => ({ type: "TOGGLE_MODAL" });
